@if (context?.attachments) {
    <div class="m-attachments">
        @for (attachment of context.attachments; track attachment) {
            <div class="m-attachment">
                <div class="m-attachment-image-wrapper">
                    <div class="m-attachment-image-actions">
                        @if (attachment.url) {
                            <app-icon-button
                                (click)="downloadAttachment(attachment)"
                                icon="download"
                                text="general.download"
                            >
                            </app-icon-button>
                        }
                    </div>
                    <app-attachment-photo
                        class="m-attachment-image"
                        [alt]="attachment.name"
                        [src]="attachment.preview"
                        (click)="openGallery(attachment.id); $event.stop()"
                    />
                </div>
                <span class="m-attachment-name mt-8">
                    {{ attachment.name }}
                </span>
            </div>
        }
    </div>
}
